import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.map.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import Vue from 'vue';
import { getMatchedComponentsInstances, getChildrenComponentInstancesUsingFetch, promisify, globalHandleError, urlJoin, sanitizeComponent } from './utils';
import NuxtError from '../layouts/error.vue';
import NuxtLoading from './components/nuxt-loading.vue';
import '../node_modules/@web/shared-digital-library/css/custom-grid.css';
import '../node_modules/@web/shared-digital-library/css/fluid-font.css';
import '../assets/scss/app.scss';
var _77180f1e = function _77180f1e() {
  return import('../layouts/blank.vue' /* webpackChunkName: "layouts/blank" */).then(function (m) {
    return sanitizeComponent(m.default || m);
  });
};
var _996cf988 = function _996cf988() {
  return import('../layouts/checkout.vue' /* webpackChunkName: "layouts/checkout" */).then(function (m) {
    return sanitizeComponent(m.default || m);
  });
};
var _6f6c098b = function _6f6c098b() {
  return import('../layouts/default.vue' /* webpackChunkName: "layouts/default" */).then(function (m) {
    return sanitizeComponent(m.default || m);
  });
};
var _77430317 = function _77430317() {
  return import('../layouts/empty.vue' /* webpackChunkName: "layouts/empty" */).then(function (m) {
    return sanitizeComponent(m.default || m);
  });
};
var resolvedLayouts = {};
var layouts = {
  "_blank": _77180f1e,
  "_checkout": _996cf988,
  "_default": _6f6c098b,
  "_empty": _77430317
};
export default {
  render: function render(h, props) {
    var loadingEl = h('NuxtLoading', {
      ref: 'loading'
    });
    var layoutEl = h(this.layout || 'nuxt');
    var templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl]);
    var transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter: function beforeEnter(el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(function () {
            window.$nuxt.$emit('triggerScroll');
          });
        }
      }
    }, [templateEl]);
    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [loadingEl, transitionEl]);
  },
  data: function data() {
    return {
      isOnline: true,
      layout: null,
      layoutName: '',
      nbFetching: 0
    };
  },
  beforeCreate: function beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt);
  },
  created: function created() {
    // Add this.$nuxt in child instances
    this.$root.$options.$nuxt = this;
    if (process.client) {
      // add to window so we can listen when ready
      window.$nuxt = this;
      this.refreshOnlineStatus();
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus);
      window.addEventListener('offline', this.refreshOnlineStatus);
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error;
    // Add $nuxt.context
    this.context = this.$options.context;
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.$loading = _this.$refs.loading;
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },
  computed: {
    isOffline: function isOffline() {
      return !this.isOnline;
    },
    isFetching: function isFetching() {
      return this.nbFetching > 0;
    }
  },
  methods: {
    refreshOnlineStatus: function refreshOnlineStatus() {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true;
        } else {
          this.isOnline = window.navigator.onLine;
        }
      }
    },
    refresh: function refresh() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var pages, promises;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              pages = getMatchedComponentsInstances(_this2.$route);
              if (pages.length) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              _this2.$loading.start();
              promises = pages.map(function (page) {
                var p = [];

                // Old fetch
                if (page.$options.fetch && page.$options.fetch.length) {
                  p.push(promisify(page.$options.fetch, _this2.context));
                }
                if (page.$fetch) {
                  p.push(page.$fetch());
                } else {
                  // Get all component instance to call $fetch
                  var _iterator = _createForOfIteratorHelper(getChildrenComponentInstancesUsingFetch(page.$vnode.componentInstance)),
                    _step;
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var component = _step.value;
                      p.push(component.$fetch());
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                }
                if (page.$options.asyncData) {
                  p.push(promisify(page.$options.asyncData, _this2.context).then(function (newData) {
                    for (var key in newData) {
                      Vue.set(page.$data, key, newData[key]);
                    }
                  }));
                }
                return Promise.all(p);
              });
              _context2.prev = 5;
              _context2.next = 8;
              return Promise.all(promises);
            case 8:
              _context2.next = 15;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](5);
              _this2.$loading.fail(_context2.t0);
              globalHandleError(_context2.t0);
              _this2.error(_context2.t0);
            case 15:
              _this2.$loading.finish();
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[5, 10]]);
      }))();
    },
    errorChanged: function errorChanged() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var errorLayout;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this3.nuxt.err) {
                _context3.next = 7;
                break;
              }
              if (_this3.$loading) {
                if (_this3.$loading.fail) {
                  _this3.$loading.fail(_this3.nuxt.err);
                }
                if (_this3.$loading.finish) {
                  _this3.$loading.finish();
                }
              }
              errorLayout = (NuxtError.options || NuxtError).layout;
              if (typeof errorLayout === 'function') {
                errorLayout = errorLayout(_this3.context);
              }
              _context3.next = 6;
              return _this3.loadLayout(errorLayout);
            case 6:
              _this3.setLayout(errorLayout);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    setLayout: function setLayout(layout) {
      if (!layout || !resolvedLayouts['_' + layout]) {
        layout = 'default';
      }
      this.layoutName = layout;
      var _layout = '_' + layout;
      this.layout = resolvedLayouts[_layout];
      return this.layout;
    },
    loadLayout: function loadLayout(layout) {
      var _this4 = this;
      var undef = !layout;
      var nonexistent = !(layouts['_' + layout] || resolvedLayouts['_' + layout]);
      var _layout = '_' + (undef || nonexistent ? 'default' : layout);
      if (resolvedLayouts[_layout]) {
        return Promise.resolve(resolvedLayouts[_layout]);
      }
      return layouts[_layout]().then(function (Component) {
        resolvedLayouts[_layout] = Component;
        delete layouts[_layout];
        return resolvedLayouts[_layout];
      }).catch(function (e) {
        if (_this4.$nuxt) {
          return _this4.$nuxt.error({
            statusCode: 500,
            message: e.message
          });
        }
      });
    }
  },
  components: {
    NuxtLoading: NuxtLoading
  }
};